import { useEffect, useState } from 'react'

import { useVisitorChannelContext } from '@liveHelper/context/VisitorChannelContext/VisitorChannelContext'
import {
  conversationSelector,
  paramsSelector,
  useStore,
} from '@liveHelper/models/store'

import { useDocumentTitle } from '@core/hooks/useDocumentTitle'
import { PIP_IFRAME_NAME } from '@core/pictureInPicture/constants'

/**
 * Hook that sends a page_view event to the visitor channel when page loads
 */
export const useSendPageView = () => {
  const params = useStore(paramsSelector)
  const conversation = useStore(conversationSelector)

  const title = useDocumentTitle()
  const channel = useVisitorChannelContext()

  const [url, setUrl] = useState<string>('')

  useEffect(() => {
    if (channel) {
      if (url !== window.location.href) {
        setUrl(window.location.href)
        channel.push('page_view', {
          page_title: title,
          page_url: window.location.href,
        })
      }
    }
  }, [title, channel, url])

  // at current time we don't have mechanism to listen for PIP start,
  // so we need to check if PIP is enabled and we have active conversation
  // and then start sending page_view events based on load event of PIP iframe
  useEffect(() => {
    if (!channel || !conversation || !params.pip) {
      return
    }
    let iframe
    const callback = () => {
      channel.push('page_view', {
        page_url: iframe?.contentWindow.location.href,
        page_title: iframe?.contentDocument?.title,
      })
    }
    // interval check if iframe is not page, because it may not be available when PIP fails
    // if iframe is found, we listen for load event and send page_view event
    const interval = setInterval(() => {
      iframe = document.getElementsByName(
        PIP_IFRAME_NAME,
      )[0] as HTMLIFrameElement
      if (iframe) {
        clearInterval(interval)
        iframe.addEventListener('load', callback)
      }
    }, 250)
    // if PIP iframe is not found within 30seconds, we stop interval since it probably faileds
    const cleanupTimeout = setTimeout(() => {
      clearInterval(interval)
    }, 10000)
    return () => {
      clearInterval(interval)
      clearTimeout(cleanupTimeout)
      iframe?.removeEventListener('load', callback)
    }
  }, [channel, conversation, params])
}
